export const OTHER = "OTHER";
export const CURRENT_APP = "ERDX_FE";
export const ERDX_BE = "erdx_be";
export const WEBSITE_FE = "website-fe";
